import type { SVGProps } from 'react'

interface PampaBiomeIconProps extends SVGProps<SVGSVGElement> {}

export function PampaBiomeIcon(props: PampaBiomeIconProps) {
  return (
    <svg
      width={34}
      height={34}
      viewBox="0 0 34 34"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M9.36.357v.005l.007.004.02.02.07.073a26.376 26.376 0 011.13 1.265c.728.867 1.706 2.12 2.726 3.689C14.62 7.42 16.01 9.973 17 12.897c.993-2.924 2.38-5.476 3.687-7.484a38.84 38.84 0 012.727-3.69c.364-.432.74-.854 1.13-1.264l.07-.073.019-.02.005-.004a1.217 1.217 0 012.076.855v12.399c.61-1.268 1.275-2.3 1.929-3.133.913-1.16 1.797-1.923 2.472-2.404.345-.247.71-.464 1.093-.648l.08-.037.027-.012.012-.005h.005l.002-.002A1.214 1.214 0 0134 8.502v18.213A7.285 7.285 0 0126.714 34H7.286A7.286 7.286 0 010 26.715V8.502a1.214 1.214 0 011.666-1.127l.007.002.012.005.027.012c.118.046.231.102.34.165.209.112.496.282.833.523.678.478 1.56 1.24 2.472 2.404.656.83 1.32 1.862 1.929 3.132V1.216A1.214 1.214 0 019.36.356z"
        fill="currentColor"
      />
    </svg>
  )
}
